var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUndrawProgramming(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "787px",
    height: "670px",
    viewBox: "0 0 787 670",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "undraw_programming 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "undraw_programming"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F2F2F2",
    fillRule: "nonzero",
    cx: 458.32136,
    cy: 200.18162,
    r: 26.70075
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.4475,623.15194 C705.1352,592.92305 724.09102,542.12648 712.22385,493.6696 C711.928977,492.4656 711.617753,491.264333 711.29018,490.0658 C703.42276,461.30237 683.95851,433.96522 655.59018,424.77451 C631.77047,417.05757 605.77056,422.99177 580.92082,419.92302 C532.13946,413.89885 494.32025,374.42902 467.70967,333.10369 C441.09903,291.77823 420.64785,245.52038 385.2881,211.37956 C327.00331,155.1042 231.92618,142.98807 159.66139,179.61912 C87.3967,216.25029 41.36484,297.51949 43.32797,378.51441 C45.29119,459.50941 93.37429,536.94617 163.20289,578.03141 C188.85511,593.12441 218.52427,603.81663 248.05115,600.07518 C273.67126,596.82877 296.95023,583.06254 322.44976,578.97559 C362.54091,572.54991 402.37663,590.67643 437.05244,611.79934 C471.72815,632.92222 505.22251,657.95922 544.6268,667.75176 C582.88828,677.26026 630.29048,649.92996 665.4475,623.15194 Z",
    id: "Path",
    fill: "#F2F2F2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.42597,181.31995 C607.55591,180.73995 606.67597,180.18995 605.80591,179.62995 C580.656917,163.545717 553.701287,150.479067 525.49591,140.69995 L518.95591,230.91995 L477.49591,230.91995 L477.49591,127.52995 C474.88591,126.98995 472.25591,126.47995 469.62591,125.99995 L469.62591,230.91995 L420.35584,230.91995 C363.873738,230.91995 318.085942,185.132172 318.08592,128.65007 L318.08592,128.64997 C315.44592,129.21997 312.82592,129.82997 310.20592,130.47997 L310.20592,230.91997 L270.07592,230.91997 L263.84592,144.88997 C234.86059,156.006266 207.343106,170.62472 181.90592,188.41997 C181.46592,188.71997 181.02592,189.02997 180.59592,189.32997 C178.38592,190.87997 176.20592,192.45997 174.03592,194.05997 L174.03592,538.24997 L292.30592,538.24997 L290.21592,509.29997 L278.71592,350.34997 L510.30592,350.34997 L498.80592,509.29997 L496.71592,538.24997 L613.67592,538.24997 L613.67592,184.79997 C611.935893,183.619997 610.18591,182.45999 608.42597,181.31995 Z M310.20597,324.09995 L276.81597,324.09995 L270.64597,238.79995 L310.20597,238.79995 L310.20597,324.09995 Z M469.62597,324.09995 L413.54597,324.09995 L413.54597,322.40995 C413.546039,320.769158 412.893582,319.195694 411.732429,318.036417 C410.571276,316.87714 408.99676,316.227229 407.35597,316.22995 L382.97597,316.22995 C381.336734,316.229305 379.764453,316.880203 378.605338,318.039318 C377.446223,319.198433 376.795325,320.770714 376.79597,322.40995 L376.79597,324.09995 L318.08597,324.09995 L318.08597,238.79995 L469.62597,238.79995 L469.62597,324.09995 Z M477.49597,324.09995 L477.49597,238.79995 L518.38597,238.79995 L512.21597,324.09995 L477.49597,324.09995 Z",
    id: "Shape",
    fill: "#3F3D56",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 264,
    y: 0,
    width: 245,
    height: 590
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.00000002e-05,560.2908 C8.68722284,570.584295 18.0834616,580.257877 28.11997,589.2408 L758.69997,590.2408 C768.736478,581.257877 778.132717,571.584295 786.81997,561.2908 L-3.00000002e-05,560.2908 Z",
    id: "Path",
    fill: "#3F3D56",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.4299,467.59132 L495.4299,553.29532 C495.431698,555.569471 497.274809,557.412587 499.54896,557.41439 L626.55345,557.41439 C628.827607,557.412598 630.670728,555.569477 630.67252,553.29532 L630.67252,467.59132 C630.667118,465.319399 628.825376,463.479691 626.55345,463.4768 L499.54897,463.4768 C497.277047,463.479697 495.435308,465.319401 495.4299,467.59132 L495.4299,467.59132 Z",
    id: "Path",
    fill: "#3F3D56",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.40936,468.65768 L498.40936,552.23807 C498.411463,553.453003 499.395837,554.437377 500.61077,554.43948 L625.49623,554.43948 C626.711165,554.437383 627.695543,553.453005 627.69764,552.23807 L627.69764,468.65768 C627.69764,467.441178 626.712729,466.454327 625.49623,466.45168 L500.61077,466.45168 C499.394275,466.454338 498.40936,467.441182 498.40936,468.65768 L498.40936,468.65768 Z",
    id: "Path",
    fill: "#44FF46",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.77373,570.00987 C493.245102,570.600919 493.961204,570.943535 494.71719,570.939742 L630.70914,570.939742 C631.462323,570.938768 632.17502,570.598632 632.649481,570.013677 C633.123943,569.428723 633.309696,568.661178 633.1552,567.92401 L631.0442,557.89679 C630.866431,557.065962 630.279948,556.381715 629.48609,556.07895 C629.203202,555.967964 628.901971,555.911144 628.59809,555.911449 L496.81982,555.911449 C496.515939,555.911139 496.214707,555.967959 495.93182,556.07895 C495.137937,556.381679 494.55144,557.065942 494.37371,557.89679 L492.26271,567.92401 C492.110603,568.660768 492.298289,569.426856 492.77373,570.00987 L492.77373,570.00987 Z",
    id: "Path",
    fill: "#2F2E41",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3F3D56",
    fillRule: "nonzero",
    transform: "translate(625.538005, 558.973845) rotate(-180.000000) translate(-625.538005, -558.973845) ",
    x: 623.44376,
    y: 557.7173,
    width: 4.18849,
    height: 2.51309,
    rx: 0.48819
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3F3D56",
    fillRule: "nonzero",
    transform: "translate(617.161025, 558.973845) rotate(-180.000000) translate(-617.161025, -558.973845) ",
    x: 615.06678,
    y: 557.7173,
    width: 4.18849,
    height: 2.51309,
    rx: 0.48819
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3F3D56",
    fillRule: "nonzero",
    transform: "translate(608.784045, 558.973845) rotate(-180.000000) translate(-608.784045, -558.973845) ",
    x: 606.6898,
    y: 557.7173,
    width: 4.18849,
    height: 2.51309,
    rx: 0.48819
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3F3D56",
    fillRule: "nonzero",
    transform: "translate(600.407065, 558.973845) rotate(-180.000000) translate(-600.407065, -558.973845) ",
    x: 598.31282,
    y: 557.7173,
    width: 4.18849,
    height: 2.51309,
    rx: 0.48819
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3F3D56",
    fillRule: "nonzero",
    transform: "translate(592.030075, 558.973845) rotate(-180.000000) translate(-592.030075, -558.973845) ",
    x: 589.93583,
    y: 557.7173,
    width: 4.18849,
    height: 2.51309,
    rx: 0.48819
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3F3D56",
    fillRule: "nonzero",
    transform: "translate(583.653095, 558.973845) rotate(-180.000000) translate(-583.653095, -558.973845) ",
    x: 581.55885,
    y: 557.7173,
    width: 4.18849,
    height: 2.51309,
    rx: 0.48819
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3F3D56",
    fillRule: "nonzero",
    transform: "translate(575.276115, 558.973845) rotate(-180.000000) translate(-575.276115, -558.973845) ",
    x: 573.18187,
    y: 557.7173,
    width: 4.18849,
    height: 2.51309,
    rx: 0.48819
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3F3D56",
    fillRule: "nonzero",
    transform: "translate(566.899135, 558.973845) rotate(-180.000000) translate(-566.899135, -558.973845) ",
    x: 564.80489,
    y: 557.7173,
    width: 4.18849,
    height: 2.51309,
    rx: 0.48819
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3F3D56",
    fillRule: "nonzero",
    transform: "translate(558.522155, 558.973845) rotate(-180.000000) translate(-558.522155, -558.973845) ",
    x: 556.42791,
    y: 557.7173,
    width: 4.18849,
    height: 2.51309,
    rx: 0.48819
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3F3D56",
    fillRule: "nonzero",
    transform: "translate(550.145175, 558.973845) rotate(-180.000000) translate(-550.145175, -558.973845) ",
    x: 548.05093,
    y: 557.7173,
    width: 4.18849,
    height: 2.51309,
    rx: 0.48819
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3F3D56",
    fillRule: "nonzero",
    transform: "translate(541.768185, 558.973845) rotate(-180.000000) translate(-541.768185, -558.973845) ",
    x: 539.67394,
    y: 557.7173,
    width: 4.18849,
    height: 2.51309,
    rx: 0.48819
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3F3D56",
    fillRule: "nonzero",
    transform: "translate(533.391205, 558.973845) rotate(-180.000000) translate(-533.391205, -558.973845) ",
    x: 531.29696,
    y: 557.7173,
    width: 4.18849,
    height: 2.51309,
    rx: 0.48819
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3F3D56",
    fillRule: "nonzero",
    transform: "translate(525.014215, 558.973845) rotate(-180.000000) translate(-525.014215, -558.973845) ",
    x: 522.91997,
    y: 557.7173,
    width: 4.18849,
    height: 2.51309,
    rx: 0.48819
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3F3D56",
    fillRule: "nonzero",
    transform: "translate(516.637245, 558.973845) rotate(-180.000000) translate(-516.637245, -558.973845) ",
    x: 514.543,
    y: 557.7173,
    width: 4.18849,
    height: 2.51309,
    rx: 0.48819
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3F3D56",
    fillRule: "nonzero",
    transform: "translate(508.260265, 558.973845) rotate(-180.000000) translate(-508.260265, -558.973845) ",
    x: 506.16602,
    y: 557.7173,
    width: 4.18849,
    height: 2.51309,
    rx: 0.48819
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3F3D56",
    fillRule: "nonzero",
    transform: "translate(499.883275, 558.973845) rotate(-180.000000) translate(-499.883275, -558.973845) ",
    x: 497.78903,
    y: 557.7173,
    width: 4.18849,
    height: 2.51309,
    rx: 0.48819
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3F3D56",
    fillRule: "nonzero",
    transform: "translate(625.636995, 563.162335) rotate(-180.000000) translate(-625.636995, -563.162335) ",
    x: 623.54275,
    y: 561.90579,
    width: 4.18849,
    height: 2.51309,
    rx: 0.48819
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3F3D56",
    fillRule: "nonzero",
    transform: "translate(617.260015, 563.162335) rotate(-180.000000) translate(-617.260015, -563.162335) ",
    x: 615.16577,
    y: 561.90579,
    width: 4.18849,
    height: 2.51309,
    rx: 0.48819
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3F3D56",
    fillRule: "nonzero",
    transform: "translate(608.883025, 563.162335) rotate(-180.000000) translate(-608.883025, -563.162335) ",
    x: 606.78878,
    y: 561.90579,
    width: 4.18849,
    height: 2.51309,
    rx: 0.48819
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3F3D56",
    fillRule: "nonzero",
    transform: "translate(600.506045, 563.162335) rotate(-180.000000) translate(-600.506045, -563.162335) ",
    x: 598.4118,
    y: 561.90579,
    width: 4.18849,
    height: 2.51309,
    rx: 0.48819
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3F3D56",
    fillRule: "nonzero",
    transform: "translate(592.129065, 563.162335) rotate(-180.000000) translate(-592.129065, -563.162335) ",
    x: 590.03482,
    y: 561.90579,
    width: 4.18849,
    height: 2.51309,
    rx: 0.48819
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3F3D56",
    fillRule: "nonzero",
    transform: "translate(583.752085, 563.162335) rotate(-180.000000) translate(-583.752085, -563.162335) ",
    x: 581.65784,
    y: 561.90579,
    width: 4.18849,
    height: 2.51309,
    rx: 0.48819
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3F3D56",
    fillRule: "nonzero",
    transform: "translate(575.375105, 563.162335) rotate(-180.000000) translate(-575.375105, -563.162335) ",
    x: 573.28086,
    y: 561.90579,
    width: 4.18849,
    height: 2.51309,
    rx: 0.48819
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3F3D56",
    fillRule: "nonzero",
    transform: "translate(566.998125, 563.162335) rotate(-180.000000) translate(-566.998125, -563.162335) ",
    x: 564.90388,
    y: 561.90579,
    width: 4.18849,
    height: 2.51309,
    rx: 0.48819
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3F3D56",
    fillRule: "nonzero",
    transform: "translate(558.621135, 563.162335) rotate(-180.000000) translate(-558.621135, -563.162335) ",
    x: 556.52689,
    y: 561.90579,
    width: 4.18849,
    height: 2.51309,
    rx: 0.48819
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3F3D56",
    fillRule: "nonzero",
    transform: "translate(550.244155, 563.162335) rotate(-180.000000) translate(-550.244155, -563.162335) ",
    x: 548.14991,
    y: 561.90579,
    width: 4.18849,
    height: 2.51309,
    rx: 0.48819
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3F3D56",
    fillRule: "nonzero",
    transform: "translate(541.867175, 563.162335) rotate(-180.000000) translate(-541.867175, -563.162335) ",
    x: 539.77293,
    y: 561.90579,
    width: 4.18849,
    height: 2.51309,
    rx: 0.48819
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3F3D56",
    fillRule: "nonzero",
    transform: "translate(533.490195, 563.162335) rotate(-180.000000) translate(-533.490195, -563.162335) ",
    x: 531.39595,
    y: 561.90579,
    width: 4.18849,
    height: 2.51309,
    rx: 0.48819
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3F3D56",
    fillRule: "nonzero",
    transform: "translate(525.113215, 563.162335) rotate(-180.000000) translate(-525.113215, -563.162335) ",
    x: 523.01897,
    y: 561.90579,
    width: 4.18849,
    height: 2.51309,
    rx: 0.48819
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3F3D56",
    fillRule: "nonzero",
    transform: "translate(516.736225, 563.162335) rotate(-180.000000) translate(-516.736225, -563.162335) ",
    x: 514.64198,
    y: 561.90579,
    width: 4.18849,
    height: 2.51309,
    rx: 0.48819
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3F3D56",
    fillRule: "nonzero",
    transform: "translate(508.359245, 563.162335) rotate(-180.000000) translate(-508.359245, -563.162335) ",
    x: 506.265,
    y: 561.90579,
    width: 4.18849,
    height: 2.51309,
    rx: 0.48819
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3F3D56",
    fillRule: "nonzero",
    transform: "translate(499.982265, 563.162335) rotate(-180.000000) translate(-499.982265, -563.162335) ",
    x: 497.88802,
    y: 561.90579,
    width: 4.18849,
    height: 2.51309,
    rx: 0.48819
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3F3D56",
    fillRule: "nonzero",
    transform: "translate(570.767765, 568.188525) rotate(-180.000000) translate(-570.767765, -568.188525) ",
    x: 554.0138,
    y: 566.93198,
    width: 33.50793,
    height: 2.51309,
    rx: 0.48819
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 515.63106,
    y: 484.73707,
    width: 5.96585,
    height: 3.12216,
    rx: 1.56108
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 548.15407,
    y: 484.73707,
    width: 5.96585,
    height: 3.12216,
    rx: 1.56108
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 557.36892,
    y: 484.73707,
    width: 5.96585,
    height: 3.12216,
    rx: 1.56108
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 524.47742,
    y: 484.4768,
    width: 20.79613,
    height: 3.12216,
    rx: 1.56108
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 567.84144,
    y: 484.4768,
    width: 20.79613,
    height: 3.12216,
    rx: 1.56108
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 524.30386,
    y: 491.78373,
    width: 5.96585,
    height: 3.12216,
    rx: 1.56108
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 556.82687,
    y: 491.78373,
    width: 5.96585,
    height: 3.12216,
    rx: 1.56108
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 566.04172,
    y: 491.78373,
    width: 5.96585,
    height: 3.12216,
    rx: 1.56108
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 533.15023,
    y: 491.52345,
    width: 20.79613,
    height: 3.12216,
    rx: 1.56108
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 576.51424,
    y: 491.52345,
    width: 20.79613,
    height: 3.12216,
    rx: 1.56108
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 532.97666,
    y: 498.83038,
    width: 5.96585,
    height: 3.12216,
    rx: 1.56108
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 565.49967,
    y: 498.83038,
    width: 5.96585,
    height: 3.12216,
    rx: 1.56108
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 574.71453,
    y: 498.83038,
    width: 5.96585,
    height: 3.12216,
    rx: 1.56108
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 541.82303,
    y: 498.57011,
    width: 20.79613,
    height: 3.12216,
    rx: 1.56108
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 585.18704,
    y: 498.57011,
    width: 20.79613,
    height: 3.12216,
    rx: 1.56108
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 541.64947,
    y: 505.87703,
    width: 5.96585,
    height: 3.12216,
    rx: 1.56108
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 574.17248,
    y: 505.87703,
    width: 5.96585,
    height: 3.12216,
    rx: 1.56108
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 583.38733,
    y: 505.87703,
    width: 5.96585,
    height: 3.12216,
    rx: 1.56108
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 550.49583,
    y: 505.61676,
    width: 20.79613,
    height: 3.12216,
    rx: 1.56108
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 548.15407,
    y: 533.89751,
    width: 5.96585,
    height: 3.12216,
    rx: 1.56108
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 557.36892,
    y: 533.89751,
    width: 5.96585,
    height: 3.12216,
    rx: 1.56108
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 567.84144,
    y: 534.15779,
    width: 20.79613,
    height: 3.12216,
    rx: 1.56108
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 515.63106,
    y: 533.89751,
    width: 5.96585,
    height: 3.12216,
    rx: 1.56108
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 524.47742,
    y: 534.15779,
    width: 20.79613,
    height: 3.12216,
    rx: 1.56108
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 524.30386,
    y: 526.85086,
    width: 5.96585,
    height: 3.12216,
    rx: 1.56108
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 556.82687,
    y: 526.85086,
    width: 5.96585,
    height: 3.12216,
    rx: 1.56108
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 566.04172,
    y: 526.85086,
    width: 5.96585,
    height: 3.12216,
    rx: 1.56108
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 533.15023,
    y: 527.11113,
    width: 20.79613,
    height: 3.12216,
    rx: 1.56108
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 532.97666,
    y: 519.80421,
    width: 5.96585,
    height: 3.12216,
    rx: 1.56108
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 565.49967,
    y: 519.80421,
    width: 5.96585,
    height: 3.12216,
    rx: 1.56108
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 574.71453,
    y: 519.80421,
    width: 5.96585,
    height: 3.12216,
    rx: 1.56108
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 541.82303,
    y: 520.06448,
    width: 20.79613,
    height: 3.12216,
    rx: 1.56108
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 541.64947,
    y: 512.75755,
    width: 5.96585,
    height: 3.12216,
    rx: 1.56108
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 574.17248,
    y: 512.75755,
    width: 5.96585,
    height: 3.12216,
    rx: 1.56108
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 583.38733,
    y: 512.75755,
    width: 5.96585,
    height: 3.12216,
    rx: 1.56108
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 550.49583,
    y: 513.01783,
    width: 20.79613,
    height: 3.12216,
    rx: 1.56108
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.68997,463.4808 L191.68997,566.0408 L263.539975,566.0408 L263.539975,463.4808 C263.542475,461.966548 262.556723,460.627872 261.10997,460.1808 C260.777796,460.071086 260.429773,460.017024 260.07997,460.020615 L195.15997,460.020615 C194.240855,460.019016 193.358727,460.382659 192.707876,461.031633 C192.057025,461.680608 191.690839,462.561684 191.68997,463.4808 L191.68997,463.4808 Z M219.72997,498.7208 C219.769008,494.512534 223.191523,491.12162 227.39997,491.12162 C231.608417,491.12162 235.030932,494.512534 235.06997,498.7208 L235.06997,510.6208 C235.048417,514.841537 231.620762,518.251734 227.39997,518.251734 C223.179178,518.251734 219.751523,514.841537 219.72997,510.6208 L219.72997,498.7208 Z",
    id: "Shape",
    fill: "#2F2E41",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.47003,562.76087 L191.47003,572.65087 C191.4734,573.717009 192.333922,574.58199 193.40003,574.59087 L261.83003,574.59087 C262.897619,574.58552 263.76003,573.718473 263.76003,572.65087 L263.76003,562.76087 L191.47003,562.76087 Z",
    id: "Path",
    fill: "#3F3D56",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.65997,308.96087 L78.65997,496.22079 C78.6639073,501.189721 82.6910391,505.216853 87.65997,505.22079 L365.15997,505.22079 C370.12891,505.216875 374.156055,501.18973 374.15997,496.22079 L374.15997,308.96087 C374.148147,303.996833 370.124017,299.977174 365.15997,299.97087 L87.65997,299.97087 C82.6959319,299.977196 78.6718149,303.996842 78.65997,308.96087 Z",
    id: "Path",
    fill: "#3F3D56",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.16997,311.2908 L85.16997,493.9108 C85.1745553,496.565388 87.325382,498.716215 89.97997,498.7208 L362.84997,498.7208 C365.504567,498.716237 367.655407,496.565397 367.65997,493.9108 L367.65997,311.2908 C367.65997,308.632795 365.507969,306.476573 362.84997,306.4708 L89.97997,306.4708 C87.3219802,306.476595 85.16997,308.632804 85.16997,311.2908 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.80997,573.9208 C136.37267,574.626362 137.227513,575.035361 138.12997,575.030838 L300.46997,575.030838 C301.369085,575.029677 302.219871,574.623639 302.786263,573.925349 C303.352654,573.227058 303.574399,572.310797 303.38997,571.4308 L300.86997,559.4608 C300.657746,558.469013 299.957631,557.652212 299.00997,557.2908 C298.672287,557.15832 298.312711,557.090492 297.94997,557.090849 L140.63997,557.090849 C140.277229,557.090486 139.917652,557.158314 139.57997,557.2908 C138.632282,557.652173 137.932151,558.468992 137.71997,559.4608 L135.19997,571.4308 C135.018387,572.310302 135.242425,573.224819 135.80997,573.9208 Z",
    id: "Path",
    fill: "#2F2E41",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.99448,331.62753 L98.67112,331.62753 C98.1191359,331.61528 97.678053,331.1643 97.678053,330.61218 C97.678053,330.06006 98.1191359,329.60908 98.67112,329.59683 L353.99448,329.59683 C354.546464,329.60908 354.987547,330.06006 354.987547,330.61218 C354.987547,331.1643 354.546464,331.61528 353.99448,331.62753 L353.99448,331.62753 Z",
    id: "Path",
    fill: "#3F3D56",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#3F3D56",
    fillRule: "nonzero",
    cx: 116.05131,
    cy: 318.32963,
    rx: 5.95043,
    ry: 6.08304
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#3F3D56",
    fillRule: "nonzero",
    cx: 136.60733,
    cy: 318.32963,
    rx: 5.95043,
    ry: 6.08304
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#3F3D56",
    fillRule: "nonzero",
    cx: 157.16336,
    cy: 318.32963,
    rx: 5.95043,
    ry: 6.08304
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.61634,313.75087 L327.01634,313.75087 C326.416096,313.764858 325.936791,314.255463 325.936791,314.85587 C325.936791,315.456277 326.416096,315.946882 327.01634,315.96087 L341.61634,315.96087 C342.220535,315.952345 342.705858,315.460125 342.705858,314.85587 C342.705858,314.251615 342.220535,313.759395 341.61634,313.75087 Z",
    id: "Path",
    fill: "#3F3D56",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.61634,317.90087 L327.01634,317.90087 C326.415582,317.914151 325.935499,318.404965 325.935499,319.00587 C325.935499,319.606775 326.415582,320.097589 327.01634,320.11087 L341.61634,320.11087 C342.221429,320.103589 342.708123,319.611002 342.708123,319.00587 C342.708123,318.400738 342.221429,317.908151 341.61634,317.90087 L341.61634,317.90087 Z",
    id: "Path",
    fill: "#3F3D56",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.61634,322.05081 L327.01634,322.05081 C326.416096,322.064798 325.936791,322.555403 325.936791,323.15581 C325.936791,323.756217 326.416096,324.246822 327.01634,324.26081 L341.61634,324.26081 C342.220535,324.252285 342.705858,323.760065 342.705858,323.15581 C342.705858,322.551555 342.220535,322.059335 341.61634,322.05081 Z",
    id: "Path",
    fill: "#3F3D56",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.59572,567.10125 C694.499583,569.732922 696.996701,571.482048 699.77882,571.43225 L726.27065,570.75047 C729.076271,570.69582 731.510864,568.80012 732.2515,566.09347 L736.00038,526.00626 C737.330449,526.608808 738.778416,526.906329 740.23831,526.87705 C743.688885,526.790431 746.831137,524.869532 748.48141,521.837937 C750.131683,518.806342 750.039261,515.124623 748.23896,512.179647 C746.438658,509.234671 743.203985,507.473851 739.75341,507.56047 C739.169901,507.55859 738.587865,507.619121 738.01723,507.74103 C736.762316,506.38334 734.991906,505.619463 733.14318,505.637699 L692.39267,506.69032 C692.05463,506.702794 691.718307,506.744551 691.38748,506.81512 C689.579415,507.152169 688.005555,508.254898 687.071382,509.839203 C686.137209,511.423508 685.934069,513.334471 686.5143,515.07976 L693.59572,567.10125 Z M736.76917,523.28441 L739.43681,513.73167 C739.740264,512.628177 739.747287,511.464164 739.45717,510.35709 C739.58661,510.35675 739.7008,510.2954 739.83024,510.29509 C743.638595,510.216341 746.792521,513.234192 746.8817,517.042317 C746.970878,520.850443 743.961677,524.012622 740.15381,524.11223 C738.971311,524.149196 737.801118,523.862989 736.76917,523.28441 L736.76917,523.28441 Z",
    id: "Shape",
    fill: "#2F2E41",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691.38748,506.8151 C692.25566,511.77922 702.01657,515.26897 713.75333,514.66239 C724.54604,514.16513 733.37078,510.37539 734.98754,505.88389 C734.389194,505.706922 733.76699,505.623974 733.14318,505.63801 L692.39267,506.6903 C692.05463,506.702774 691.718307,506.744531 691.38748,506.8151 L691.38748,506.8151 Z",
    id: "Path",
    fill: "#3F3D56",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M715.90435,545.07302 C715.958003,545.059444 716.009009,545.036995 716.05526,545.0066 L721.80841,541.24094 C721.949707,541.148826 722.035002,540.991593 722.035002,540.822922 C722.035002,540.654251 721.949957,540.496952 721.80873,540.40473 L715.82895,536.48806 C715.679634,536.389252 715.488865,536.37788 715.328868,536.45825 C715.168871,536.53862 715.064099,536.698448 715.05422,536.877224 C715.04434,537.056 715.130863,537.2264 715.28103,537.32391 L720.62194,540.82209 L715.50794,544.17003 C715.303459,544.303735 715.225574,544.565651 715.323772,544.789363 C715.42197,545.013075 715.667479,545.133037 715.90431,545.07303 L715.90435,545.07302 Z",
    id: "Path",
    fill: "#44FF46",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.81759,545.49206 C707.015107,545.442058 707.162527,545.277207 707.190237,545.075353 C707.217948,544.873498 707.120405,544.675019 706.94367,544.57364 L701.64061,541.5333 L706.76621,537.72607 C706.909488,537.619605 706.985084,537.444789 706.964521,537.267474 C706.943958,537.09016 706.830361,536.937284 706.666521,536.866434 C706.50268,536.795585 706.313488,536.817525 706.17021,536.92399 L700.43159,541.18664 C700.296127,541.287039 700.220457,541.449003 700.230374,541.617323 C700.24029,541.785644 700.334455,541.937602 700.48077,542.0214 L706.44602,545.44108 C706.55856,545.505672 706.691812,545.523955 706.81759,545.49206 Z",
    id: "Path",
    fill: "#44FF46",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M715.33212,548.37303 C715.380503,548.360945 715.426719,548.34143 715.46912,548.31518 C715.582528,548.246339 715.66391,548.135231 715.695333,548.006339 C715.726756,547.877448 715.705641,547.741351 715.63664,547.62804 L707.48116,534.21968 C707.337166,533.984293 707.029769,533.90995 706.794125,534.053523 C706.558481,534.197096 706.483589,534.50436 706.62674,534.74026 L714.78222,548.14861 C714.896497,548.335883 715.119442,548.42687 715.33212,548.37303 L715.33212,548.37303 Z",
    id: "Path",
    fill: "#44FF46",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#44FF46",
    fillRule: "nonzero",
    x: 209.38454,
    y: 386.82713,
    width: 50.71916,
    height: 10.8457,
    rx: 3.26417
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E6E6E6",
    fillRule: "nonzero",
    x: 183.62601,
    y: 408.51852,
    width: 102.23622,
    height: 10.8457,
    rx: 3.26417
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E6E6E6",
    fillRule: "nonzero",
    x: 183.62601,
    y: 430.20991,
    width: 102.23622,
    height: 10.8457,
    rx: 3.26417
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-77",
    transform: "translate(393.597820, 449.212380)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.39173,5.00905 L46.39173,128.77597 C46.39173,130.90239 45.24752,131.20597 43.38795,132.23737 C37.1137,135.71719 21.64795,141.91766 3.07953,132.10425 C1.17348,131.0969 1.13686838e-13,130.75646 1.13686838e-13,128.60059 L1.13686838e-13,5.80207 C1.13686838e-13,5.80207 23.59238,15.31832 46.39173,5.00905 Z",
    id: "Path",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    stroke: "#44FF46",
    fill: "#3F3D56",
    cx: 23.19587,
    cy: 4.92606,
    rx: 23.19586,
    ry: 4.92606
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.8,
    transform: "translate(0.402180, 54.787620)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 43.87703,
    cy: 1.616,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 41.235,
    cy: 2.35461,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 37.97082,
    cy: 3.39545,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 32.11811,
    cy: 4.65635,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 25.94755,
    cy: 5.40347,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 19.55709,
    cy: 5.69719,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 10.38428,
    cy: 4.43629,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 13.42349,
    cy: 5.17677,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 4.70675,
    cy: 3.39545,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 7.44122,
    cy: 3.91587,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 1.71034,
    cy: 2.35461,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 34.98211,
    cy: 4.13593,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 28.94379,
    cy: 5.17677,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 22.39112,
    cy: 5.69719,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 16.4304,
    cy: 5.69719,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.8,
    transform: "translate(0.402180, 57.787620)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 43.87703,
    cy: 1.17701,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 41.235,
    cy: 1.91563,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 37.97082,
    cy: 2.95647,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 32.11811,
    cy: 4.21737,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 25.94755,
    cy: 4.96449,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 19.55709,
    cy: 5.25821,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 10.38428,
    cy: 3.99731,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 13.42349,
    cy: 4.73779,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 4.70675,
    cy: 2.95647,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 7.44122,
    cy: 3.47689,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 1.71034,
    cy: 1.91563,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 34.98211,
    cy: 3.69695,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 28.94379,
    cy: 4.73779,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 22.39112,
    cy: 5.25821,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 16.4304,
    cy: 5.25821,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.8,
    transform: "translate(0.402180, 59.787620)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 43.87703,
    cy: 1.73803,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 41.235,
    cy: 2.47665,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 37.97082,
    cy: 3.51749,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 32.11811,
    cy: 4.77839,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 25.94755,
    cy: 5.5255,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 19.55709,
    cy: 5.81923,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 10.38428,
    cy: 4.55833,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 13.42349,
    cy: 5.29881,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 4.70675,
    cy: 3.51749,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 7.44122,
    cy: 4.03791,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 1.71034,
    cy: 2.47665,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 34.98211,
    cy: 4.25797,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 28.94379,
    cy: 5.29881,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 22.39112,
    cy: 5.81923,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 16.4304,
    cy: 5.81923,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.8,
    transform: "translate(0.402180, 62.787620)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 43.87703,
    cy: 1.29905,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 41.235,
    cy: 2.03767,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 37.97082,
    cy: 3.07851,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 32.11811,
    cy: 4.3394,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 25.94755,
    cy: 5.08652,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 19.55709,
    cy: 5.38024,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 10.38428,
    cy: 4.11935,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 13.42349,
    cy: 4.85982,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 4.70675,
    cy: 3.07851,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 7.44122,
    cy: 3.59893,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 1.71034,
    cy: 2.03767,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 34.98211,
    cy: 3.81898,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 28.94379,
    cy: 4.85982,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 22.39112,
    cy: 5.38024,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 16.4304,
    cy: 5.38024,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.8,
    transform: "translate(0.402180, 64.787620)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 43.87703,
    cy: 1.86007,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 41.235,
    cy: 2.59868,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 37.97082,
    cy: 3.63952,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 32.11811,
    cy: 4.90042,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 25.94755,
    cy: 5.64754,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 19.55709,
    cy: 5.94126,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 10.38428,
    cy: 4.68036,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 13.42349,
    cy: 5.42084,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 4.70675,
    cy: 3.63952,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 7.44122,
    cy: 4.15994,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 1.71034,
    cy: 2.59868,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 34.98211,
    cy: 4.38,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 28.94379,
    cy: 5.42084,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 22.39112,
    cy: 5.94126,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 16.4304,
    cy: 5.94126,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.8,
    transform: "translate(0.402180, 67.787620)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 43.87703,
    cy: 1.42108,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 41.235,
    cy: 2.1597,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 37.97082,
    cy: 3.20054,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 32.11811,
    cy: 4.46144,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 25.94755,
    cy: 5.20856,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 19.55709,
    cy: 5.50228,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 10.38428,
    cy: 4.24138,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 13.42349,
    cy: 4.98186,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 4.70675,
    cy: 3.20054,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 7.44122,
    cy: 3.72096,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 1.71034,
    cy: 2.1597,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 34.98211,
    cy: 3.94102,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 28.94379,
    cy: 4.98186,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 22.39112,
    cy: 5.50228,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 16.4304,
    cy: 5.50228,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.8,
    transform: "translate(0.402180, 69.787620)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 43.87703,
    cy: 1.9821,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 41.235,
    cy: 2.72072,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 37.97082,
    cy: 3.76156,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 32.11811,
    cy: 5.02246,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 25.94755,
    cy: 5.76957,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 19.55709,
    cy: 6.0633,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 10.38428,
    cy: 4.8024,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 13.42349,
    cy: 5.54288,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 4.70675,
    cy: 3.76156,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 7.44122,
    cy: 4.28198,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 1.71034,
    cy: 2.72072,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 34.98211,
    cy: 4.50204,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 28.94379,
    cy: 5.54288,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 22.39112,
    cy: 6.0633,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 16.4304,
    cy: 6.0633,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.8,
    transform: "translate(0.402180, 72.787620)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 43.87703,
    cy: 1.54312,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 41.235,
    cy: 2.28174,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 37.97082,
    cy: 3.32258,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 32.11811,
    cy: 4.58347,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 25.94755,
    cy: 5.33059,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 19.55709,
    cy: 5.62431,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 10.38428,
    cy: 4.36342,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 13.42349,
    cy: 5.10389,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 4.70675,
    cy: 3.32258,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 7.44122,
    cy: 3.843,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 1.71034,
    cy: 2.28174,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 34.98211,
    cy: 4.06305,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 28.94379,
    cy: 5.10389,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 22.39112,
    cy: 5.62431,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 16.4304,
    cy: 5.62431,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.8,
    transform: "translate(0.402180, 75.787620)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 43.87703,
    cy: 1.10414,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 41.235,
    cy: 1.84275,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 37.97082,
    cy: 2.88359,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 32.11811,
    cy: 4.14449,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 25.94755,
    cy: 4.89161,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 19.55709,
    cy: 5.18533,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 10.38428,
    cy: 3.92443,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 13.42349,
    cy: 4.66491,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 4.70675,
    cy: 2.88359,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 7.44122,
    cy: 3.40401,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 1.71034,
    cy: 1.84275,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 34.98211,
    cy: 3.62407,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 28.94379,
    cy: 4.66491,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 22.39112,
    cy: 5.18533,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 16.4304,
    cy: 5.18533,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.8,
    transform: "translate(0.402180, 77.787620)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 43.87703,
    cy: 1.66515,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 41.235,
    cy: 2.40377,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 37.97082,
    cy: 3.44461,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 32.11811,
    cy: 4.70551,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 25.94755,
    cy: 5.45263,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 19.55709,
    cy: 5.74635,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 10.38428,
    cy: 4.48545,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 13.42349,
    cy: 5.22593,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 4.70675,
    cy: 3.44461,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 7.44122,
    cy: 3.96503,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 1.71034,
    cy: 2.40377,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 34.98211,
    cy: 4.18509,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 28.94379,
    cy: 5.22593,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 22.39112,
    cy: 5.74635,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 16.4304,
    cy: 5.74635,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.8,
    transform: "translate(0.402180, 80.787620)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 43.87703,
    cy: 1.22617,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 41.235,
    cy: 1.96479,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 37.97082,
    cy: 3.00563,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 32.11811,
    cy: 4.26653,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 25.94755,
    cy: 5.01364,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 19.55709,
    cy: 5.30737,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 10.38428,
    cy: 4.04647,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 13.42349,
    cy: 4.78695,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 4.70675,
    cy: 3.00563,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 7.44122,
    cy: 3.52605,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 1.71034,
    cy: 1.96479,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 34.98211,
    cy: 3.74611,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 28.94379,
    cy: 4.78695,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 22.39112,
    cy: 5.30737,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 16.4304,
    cy: 5.30737,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.8,
    transform: "translate(0.402180, 82.787620)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 43.87703,
    cy: 1.78719,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 41.235,
    cy: 2.52581,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 37.97082,
    cy: 3.56665,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 32.11811,
    cy: 4.82754,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 25.94755,
    cy: 5.57466,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 19.55709,
    cy: 5.86838,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 10.38428,
    cy: 4.60749,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 13.42349,
    cy: 5.34796,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 4.70675,
    cy: 3.56665,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 7.44122,
    cy: 4.08707,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 1.71034,
    cy: 2.52581,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 34.98211,
    cy: 4.30712,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 28.94379,
    cy: 5.34796,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 22.39112,
    cy: 5.86838,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 16.4304,
    cy: 5.86838,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.8,
    transform: "translate(0.402180, 85.787620)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 43.87703,
    cy: 1.34821,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 41.235,
    cy: 2.08682,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 37.97082,
    cy: 3.12766,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 32.11811,
    cy: 4.38856,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 25.94755,
    cy: 5.13568,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 19.55709,
    cy: 5.4294,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 10.38428,
    cy: 4.1685,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 13.42349,
    cy: 4.90898,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 4.70675,
    cy: 3.12766,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 7.44122,
    cy: 3.64808,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 1.71034,
    cy: 2.08682,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 34.98211,
    cy: 3.86814,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 28.94379,
    cy: 4.90898,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 22.39112,
    cy: 5.4294,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 16.4304,
    cy: 5.4294,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.8,
    transform: "translate(0.402180, 87.787620)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 43.87703,
    cy: 1.90922,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 41.235,
    cy: 2.64784,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 37.97082,
    cy: 3.68868,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 32.11811,
    cy: 4.94958,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 25.94755,
    cy: 5.6967,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 19.55709,
    cy: 5.99042,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 10.38428,
    cy: 4.72952,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 13.42349,
    cy: 5.47,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 4.70675,
    cy: 3.68868,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 7.44122,
    cy: 4.2091,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 1.71034,
    cy: 2.64784,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 34.98211,
    cy: 4.42916,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 28.94379,
    cy: 5.47,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 22.39112,
    cy: 5.99042,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 16.4304,
    cy: 5.99042,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.8,
    transform: "translate(0.402180, 90.787620)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 43.87703,
    cy: 1.47024,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 41.235,
    cy: 2.20886,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 37.97082,
    cy: 3.2497,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 32.11811,
    cy: 4.5106,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 25.94755,
    cy: 5.25771,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 19.55709,
    cy: 5.55144,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 10.38428,
    cy: 4.29054,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 13.42349,
    cy: 5.03102,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 4.70675,
    cy: 3.2497,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 7.44122,
    cy: 3.77012,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 1.71034,
    cy: 2.20886,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 34.98211,
    cy: 3.99018,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 28.94379,
    cy: 5.03102,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 22.39112,
    cy: 5.55144,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 16.4304,
    cy: 5.55144,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.8,
    transform: "translate(0.402180, 93.787620)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 43.87703,
    cy: 1.03126,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 41.235,
    cy: 1.76987,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 37.97082,
    cy: 2.81071,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 32.11811,
    cy: 4.07161,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 25.94755,
    cy: 4.81873,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 19.55709,
    cy: 5.11245,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 10.38428,
    cy: 3.85155,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 13.42349,
    cy: 4.59203,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 4.70675,
    cy: 2.81071,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 7.44122,
    cy: 3.33113,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 1.71034,
    cy: 1.76987,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 34.98211,
    cy: 3.55119,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 28.94379,
    cy: 4.59203,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 22.39112,
    cy: 5.11245,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 16.4304,
    cy: 5.11245,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.8,
    transform: "translate(0.402180, 95.787620)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 43.87703,
    cy: 1.59228,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 41.235,
    cy: 2.33089,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 37.97082,
    cy: 3.37173,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 32.11811,
    cy: 4.63263,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 25.94755,
    cy: 5.37975,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 19.55709,
    cy: 5.67347,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 10.38428,
    cy: 4.41257,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 13.42349,
    cy: 5.15305,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 4.70675,
    cy: 3.37173,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 7.44122,
    cy: 3.89215,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 1.71034,
    cy: 2.33089,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 34.98211,
    cy: 4.11221,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 28.94379,
    cy: 5.15305,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 22.39112,
    cy: 5.67347,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 16.4304,
    cy: 5.67347,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.8,
    transform: "translate(0.402180, 98.787620)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 43.87703,
    cy: 1.15329,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 41.235,
    cy: 1.89191,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 37.97082,
    cy: 2.93275,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 32.11811,
    cy: 4.19365,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 25.94755,
    cy: 4.94077,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 19.55709,
    cy: 5.23449,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 10.38428,
    cy: 3.97359,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 13.42349,
    cy: 4.71407,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 4.70675,
    cy: 2.93275,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 7.44122,
    cy: 3.45317,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 1.71034,
    cy: 1.89191,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 34.98211,
    cy: 3.67323,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 28.94379,
    cy: 4.71407,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 22.39112,
    cy: 5.23449,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 16.4304,
    cy: 5.23449,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.8,
    transform: "translate(0.402180, 100.787620)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 43.87703,
    cy: 1.71431,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 41.235,
    cy: 2.45293,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 37.97082,
    cy: 3.49377,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 32.11811,
    cy: 4.75467,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 25.94755,
    cy: 5.50178,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 19.55709,
    cy: 5.79551,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 10.38428,
    cy: 4.53461,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 13.42349,
    cy: 5.27509,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 4.70675,
    cy: 3.49377,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 7.44122,
    cy: 4.01419,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 1.71034,
    cy: 2.45293,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 34.98211,
    cy: 4.23425,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 28.94379,
    cy: 5.27509,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 22.39112,
    cy: 5.79551,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 16.4304,
    cy: 5.79551,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.8,
    transform: "translate(0.402180, 103.787620)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 43.87703,
    cy: 1.27533,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 41.235,
    cy: 2.01394,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 37.97082,
    cy: 3.05478,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 32.11811,
    cy: 4.31568,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 25.94755,
    cy: 5.0628,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 19.55709,
    cy: 5.35652,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 10.38428,
    cy: 4.09562,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 13.42349,
    cy: 4.8361,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 4.70675,
    cy: 3.05478,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 7.44122,
    cy: 3.5752,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 1.71034,
    cy: 2.01394,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 34.98211,
    cy: 3.79526,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 28.94379,
    cy: 4.8361,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 22.39112,
    cy: 5.35652,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 16.4304,
    cy: 5.35652,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.8,
    transform: "translate(0.402180, 105.787620)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 43.87703,
    cy: 1.83635,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 41.235,
    cy: 2.57496,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 37.97082,
    cy: 3.6158,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 32.11811,
    cy: 4.8767,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 25.94755,
    cy: 5.62382,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 19.55709,
    cy: 5.91754,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 10.38428,
    cy: 4.65664,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 13.42349,
    cy: 5.39712,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 4.70675,
    cy: 3.6158,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 7.44122,
    cy: 4.13622,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 1.71034,
    cy: 2.57496,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 34.98211,
    cy: 4.35628,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 28.94379,
    cy: 5.39712,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 22.39112,
    cy: 5.91754,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 16.4304,
    cy: 5.91754,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.8,
    transform: "translate(0.402180, 108.787620)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 43.87703,
    cy: 1.39736,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 41.235,
    cy: 2.13598,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 37.97082,
    cy: 3.17682,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 32.11811,
    cy: 4.43772,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 25.94755,
    cy: 5.18483,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 19.55709,
    cy: 5.47856,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 10.38428,
    cy: 4.21766,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 13.42349,
    cy: 4.95814,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 4.70675,
    cy: 3.17682,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 7.44122,
    cy: 3.69724,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 1.71034,
    cy: 2.13598,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 34.98211,
    cy: 3.9173,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 28.94379,
    cy: 4.95814,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 22.39112,
    cy: 5.47856,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 16.4304,
    cy: 5.47856,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.8,
    transform: "translate(0.402180, 110.787620)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 43.87703,
    cy: 1.95838,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 41.235,
    cy: 2.697,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 37.97082,
    cy: 3.73784,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 32.11811,
    cy: 4.99874,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 25.94755,
    cy: 5.74585,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 19.55709,
    cy: 6.03958,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 10.38428,
    cy: 4.77868,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 13.42349,
    cy: 5.51916,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 4.70675,
    cy: 3.73784,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 7.44122,
    cy: 4.25826,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 1.71034,
    cy: 2.697,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 34.98211,
    cy: 4.47832,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 28.94379,
    cy: 5.51916,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 22.39112,
    cy: 6.03958,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 16.4304,
    cy: 6.03958,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.8,
    transform: "translate(0.402180, 113.787620)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 43.87703,
    cy: 1.5194,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 41.235,
    cy: 2.25801,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 37.97082,
    cy: 3.29885,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 32.11811,
    cy: 4.55975,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 25.94755,
    cy: 5.30687,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 19.55709,
    cy: 5.60059,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 10.38428,
    cy: 4.33969,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 13.42349,
    cy: 5.08017,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 4.70675,
    cy: 3.29885,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 7.44122,
    cy: 3.81927,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 1.71034,
    cy: 2.25801,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 34.98211,
    cy: 4.03933,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 28.94379,
    cy: 5.08017,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 22.39112,
    cy: 5.60059,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 16.4304,
    cy: 5.60059,
    r: 1
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawProgramming);
export default __webpack_public_path__ + "static/media/undraw_programming.cabac74ca620c25ca0f9349007dbdfd1.svg";
export { ForwardRef as ReactComponent };